module.exports = __webpack_public_path__ + "assets/multi-select.b09c64b2.svg";